var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentTimeline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 21.1667H11V17.1667H15V15.1667H11V11.1667H9V15.1667H5V17.1667H9V21.1667ZM2.4 26.1667C1.73333 26.1667 1.16667 25.9333 0.7 25.4667C0.233333 25 0 24.4333 0 23.7667V3.23333C0 2.56666 0.233333 2 0.7 1.53333C1.16667 1.06666 1.73333 0.833328 2.4 0.833328H13L20 7.83333V23.7667C20 24.4333 19.7667 25 19.3 25.4667C18.8333 25.9333 18.2667 26.1667 17.6 26.1667H2.4ZM12 8.83333V2.83333H2.4C2.31111 2.83333 2.22222 2.87777 2.13333 2.96666C2.04444 3.05555 2 3.14444 2 3.23333V23.7667C2 23.8556 2.04444 23.9444 2.13333 24.0333C2.22222 24.1222 2.31111 24.1667 2.4 24.1667H17.6C17.6889 24.1667 17.7778 24.1222 17.8667 24.0333C17.9556 23.9444 18 23.8556 18 23.7667V8.83333H12Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentTimeline);
export default __webpack_public_path__ + "static/media/document-timeline.ab7359cd.svg";
export { ForwardRef as ReactComponent };